<template>
  <div class="columns">
    <div class="column full-width solicitudes-table">
      <admin-section-header icon="arrow-up" title="Solicitudes" />

      <div class="field has-addons">
        <div class="control">
          <a @click="goToNewRequest()" class="button is-primary is-medium">
            {{ $t('Nueva solicitud') }}
          </a>
        </div>
        <div class="control">
          <b-input
            v-model="searchEmailString"
            type="text"
            placeholder="Escriba aquí"
          />
        </div>
      </div>

      <b-table
        class="section no-padding-mobile"
        :loading="isLoading"
        :paginated="true"
        :per-page="10"
        :striped="true"
        :hoverable="true"
        default-sort-direction="desc"
        default-sort="updatedAt"
        :data="filteredRequests()"
      >
        <template slot-scope="props">
          <b-table-column :label="$t('Email')" field="GSI1SK" sortable>
            <a
              v-if="isTempEmail(props.row.email)"
              target="_blank"
              :href="
                `https://webmail.myneofintech.com/?user=${
                  props.row.email.split('@')[0]
                }`
              "
            >
              {{ props.row.email }}
            </a>
            <span v-else>
              {{ props.row.email }}
            </span>
          </b-table-column>

          <b-table-column
            :label="$t('Responsable')"
            field="request_type"
            sortable
          >
            <b-select
              @input="reasignateRequest(props.row, $event)"
              v-if="assignableUsers.includes(props.row.responsible)"
              :value="props.row.responsible"
              class="is-small"
            >
              <option v-for="user in assignableUsers" :value="user" :key="user">
                {{ user }}
              </option>
            </b-select>
            <span v-else>
              {{ props.row.responsible }}
            </span>
          </b-table-column>

          <b-table-column :label="$t('Creada')" field="createdAt" sortable>{{
            props.row.createdAt | formatTimestamp
          }}</b-table-column>
          <b-table-column
            :sortable="true"
            :label="$t('Actualizada')"
            field="updatedAt"
            >{{ props.row.updatedAt | formatTimestamp }}</b-table-column
          >
          <b-table-column :sortable="true" :label="$t('Fase')" field="phase">{{
            props.row.phase
          }}</b-table-column>
          <b-table-column :label="$t('Estado')" field="status" sortable>{{
            $t(props.row.status)
          }}</b-table-column>

          <b-table-column label=" ">
            <div class="buttons is-right">
              <button
                @click="goToRequestDetail(props.row.GSI1SK)"
                class="button is-primary"
                type="button"
              >
                <b-icon icon="eye" custom-size="default" />
              </button>
              <button
                @click="removeOnboardRequest(props.row.GSI1SK)"
                class="button is-danger"
                type="button"
              >
                <b-icon icon="trash-can" custom-size="default" />
              </button>
            </div>
          </b-table-column>
        </template>

        <section class="section" slot="empty">
          <div class="content has-text-grey has-text-centered">
            <template v-if="isLoading">
              <p>
                <b-icon icon="dots-horizontal" size="is-large" />
              </p>
              <p>{{ $t('Cargando') }}...</p>
            </template>
            <template v-else>
              <p>
                <b-icon icon="emoticon-sad" size="is-large" />
              </p>
              <p>{{ $t('No hay resultados') }}&hellip;</p>
            </template>
          </div>
        </section>
      </b-table>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import AdminSectionHeader from '@/components/admin/dasboard/AdminSectionHeader.vue'
import TwitterFeed from '@/components/admin/dasboard/TwitterFeed.vue'
import existingMyneofintechEmails from '@/constants/real_myneofintech_emails.js'
export default {
  name: 'AdminOnBoardRequestsTable',
  props: {},
  components: { TwitterFeed, AdminSectionHeader },
  data() {
    return {
      isLoading: false,
      searchEmailString: '',
      users: []
    }
  },
  computed: {
    ...mapState('onBoard', ['admin']),
    ...mapGetters('user', ['rol', 'email']),
    onboardRequests: function() {
      return this.admin.onboardRequests
    },
    assignableUsers: function() {
      let self = this
      const assignableRolesByCurrentRol = {
        admin: ['corporative_director', 'partner', 'subpartner'],
        corporative_director: ['partner', 'subpartner'],
        partner: ['subpartner'],
        subpartner: []
      }

      let assignableUsers = self.users.filter(user => {
        return assignableRolesByCurrentRol[self.rol].includes(user.rol)
      })
      assignableUsers.push({ email: self.email })
      return assignableUsers.map(user => user.email)
    }
  },
  methods: {
    ...mapActions('onBoard', [
      'getOnboardRequests',
      'deleteOnboardRequest',
      'putReassignOnboardRequest'
    ]),
    ...mapActions('user', ['getAdminUsers']),
    async callGetAdminUsers() {
      let self = this

      self.getAdminUsers().then(function(response) {
        self.users = response.data
        self.isLoading = false
      })
    },
    isTempEmail(email) {
      if (!email.includes('@myneofintech.com')) {
        return false
      }
      return !existingMyneofintechEmails.includes(email.split('@')[0])
    },
    reasignateRequest(request, email) {
      let self = this
      self.$dialog.confirm({
        message: self.$t('¿Estás seguro de querer reasignar esta solicitud?'),
        type: 'is-danger',
        onConfirm: function() {
          self
            .putReassignOnboardRequest({ requestId: request.GSI1SK, email })
            .then(function() {
              self.callGetOnboardRequests()
            })
            .catch(function() {
              alert('error')
            })
        }
      })
    },
    goToNewRequest() {
      let routeData = this.$router.resolve({
        name: 'onBoard.neofintech.phase1.1'
      })
      window.open(routeData.href, '_blank')
    },
    filteredRequests() {
      return this.admin.onboardRequests.filter(
        request =>
          request.email.includes(this.searchEmailString) ||
          request.email.includes(this.responsible)
      )
    },
    async callGetOnboardRequests() {
      let self = this
      self.isLoading = true
      this.getOnboardRequests()
        .then(function(response) {
          self.$store.commit(
            'onBoard/SET_ADMIN_ONBOARD_RESQUESTS',
            response.data
          )
          self.isLoading = false
        })
        .catch(function() {
          self.isLoading = false
        })
    },
    removeOnboardRequest(id) {
      let self = this
      self.$dialog.confirm({
        message: self.$t('¿Estás seguro? esta operación no se puede deshacer'),
        type: 'is-danger',
        onConfirm: function() {
          self
            .deleteOnboardRequest(id)
            .then(function() {
              self.callGetOnboardRequests()
            })
            .catch(function() {
              alert('error')
            })
        }
      })
    },
    goToRequestDetail(id) {
      this.$router.push({ name: 'admin.on-board.detail', params: { id: id } })
    }
  },
  mounted() {
    this.callGetAdminUsers()
    this.callGetOnboardRequests()
    this.$store.commit('layout/SUB_PAGE', {
      stack: ['Admin', this.$t('Solicitudes')],
      title: this.$t('Solicitudes')
    })
  }
}
</script>

<style scoped>
.columns {
  margin-top: 0;
  overflow: hidden;
}
.column.twitter,
.solicitudes-table {
  overflow: scroll;
}
</style>
